import Accordion from "../componentLibrary/Accordion";
import type {
  ToolboxToolItem,
  ToolboxToolSectionGroup,
} from "../utils/toolboxTools";

export default function ToolboxSectionToolsAccordion({
  section,
  onSelectTool,
}: {
  section: ToolboxToolSectionGroup;
  onSelectTool?: (tool: ToolboxToolItem) => void;
}) {
  return (
    <Accordion
      title={
        <span className="min-w-0 flex-1 text-xs font-semibold uppercase tracking-wide text-gray-600">
          {section.sectionTitle}
        </span>
      }
      className="border-gray-200"
      headerClassName="px-3 py-3"
    >
      <ul className="m-0 flex list-none flex-col gap-2 border-t border-gray-200 p-0 px-3 py-3">
        {section.tools.map((tool) => (
          <li key={`${tool.lessonId}-${tool.pageId}`}>
            <button
              type="button"
              className="flex w-full cursor-pointer select-none items-center gap-3 rounded-lg border border-gray-200 bg-gray-50 px-3 py-3 text-left transition-colors hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-electrum-300"
              aria-label={tool.pageTitle}
              onClick={onSelectTool ? () => onSelectTool(tool) : undefined}
            >
              <div className="min-w-0">
                <p className="truncate text-sm font-semibold text-gray-900">
                  {tool.pageTitle}
                </p>
              </div>
            </button>
          </li>
        ))}
      </ul>
    </Accordion>
  );
}
